<header class="app-toolbar">
  <a class="brand" routerLink="/health" aria-label="Go to home">
    <mat-icon class="brand-logo" svgIcon="cfa-logo" aria-hidden="true"></mat-icon>
    <span class="app-title">{{ appName }}</span>
  </a>

  <nav class="nav-tabs">
    <ng-content select="app-nav-tab"></ng-content>
  </nav>

  <span class="toolbar-spacer"></span>

  <div class="toolbar-actions">
    <ng-content select="app-nav-menu-item"></ng-content>

    @if (userName) {
      <span class="user-chip">
        <span class="user-avatar" aria-hidden="true">{{ initials }}</span>
        <span class="user-name">{{ userName }}</span>
      </span>
    }

    <button mat-icon-button class="theme-toggle" (click)="themeService.toggleTheme()"
            [matTooltip]="themeService.isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'">
      <mat-icon>{{ themeService.isDarkMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>

    <button mat-button class="signout-button" (click)="signout.emit()">Sign Out</button>
  </div>
</header>

<div class="app-content">
  <ng-content></ng-content>
</div>
